export function getBase64(file) {
	return new Promise((resolve, reject) => {
		//check if the file is removed and resolve to null
		if (file.status && file.status === 'removed') return resolve(null);
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
}

export function saveBlob(blob, fileName) {
	const a = document.createElement('a');
	a.href = window.URL.createObjectURL(blob);
	a.download = fileName;
	a.dispatchEvent(new MouseEvent('click'));
}

export function base64ToBlob(data, type) {
	const ab = new ArrayBuffer(data.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < data.length; i++) {
		ia[i] = data.charCodeAt(i);
	}
	return new Blob([ab], { type });
}

export function saveBase64File(content, filename) {
	return saveBlob(base64ToBlob(atob(content), ''), filename);
}
